//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

// TODO: PD-270146 - remove this file when the ContentLibraryLabelsImprovements feature flag is released

(function () {
  const curalate = angular.module('curalate');

  curalate.constant('STAT_FORMATTERS', {
    COMPLETE_NUMBER: 'completeNumber',
    NUMBER: 'number',
    PRICE: 'price',
    PERCENT: 'percent',
  });

  const statNames = {
    AVG_COMMENTS: 'avgComments',
    AVG_COMPLETION_RATE: 'avgCompletionRate',
    AVG_LIKES: 'avgLikes',
    AVG_REACH: 'avgReach',
    AVG_REPINS: 'avgRepins',
    COMMENTS: 'comments',
    ENGAGEMENT_RATE: 'engagementRate', // TODO: Remove this once Content Library stops returning it (DEV-46775)
    FOLLOWER_ENGAGEMENT_RATE: 'followerEngagementRate',
    INTERACTIONS: 'interactions',
    LIKES: 'likes',
    POTENTIAL_IMPRESSIONS: 'potentialImpressions',
    REACH_ENGAGEMENT_RATE: 'reachEngagementRate',
    TOTAL_COMMENTS: 'totalComments',
    TOTAL_IMPRESSIONS: 'totalImpressions',
    TOTAL_LIKES: 'totalLikes',
    TOTAL_REPINS: 'totalRepins',
  };

  const statLabels = {
    [statNames.AVG_COMMENTS]: 'Average Comments',
    [statNames.AVG_COMPLETION_RATE]: 'Average Completion Rate',
    [statNames.AVG_LIKES]: 'Average Likes',
    [statNames.AVG_REACH]: 'Average Reach',
    [statNames.AVG_REPINS]: 'Average Saves',
    [statNames.COMMENTS]: 'Comments',
    [statNames.ENGAGEMENT_RATE]: 'Follower Engagement Rate',
    [statNames.FOLLOWER_ENGAGEMENT_RATE]: 'Follower Engagement Rate',
    [statNames.INTERACTIONS]: 'Interactions',
    [statNames.LIKES]: 'Likes',
    [statNames.POTENTIAL_IMPRESSIONS]: 'Potential Impressions',
    [statNames.REACH_ENGAGEMENT_RATE]: 'Engagement Rate',
    [statNames.TOTAL_COMMENTS]: 'Comments',
    [statNames.TOTAL_IMPRESSIONS]: 'Total Views',
    [statNames.TOTAL_LIKES]: 'Likes',
    [statNames.TOTAL_REPINS]: 'Saves',
  };

  const statTooltips = {
    [statNames.AVG_COMMENTS]:
      'Average number of comments per post in the filtered set of media.',
    [statNames.AVG_COMPLETION_RATE]: `Average completion rate across the stories in this Collection.
                                                   Completion Rate is calculated as impressions minus exits divided by impressions.`,
    [statNames.AVG_LIKES]:
      'Average number of likes per post in the filtered set of media.',
    [statNames.AVG_REACH]:
      'Average number of unique users who have viewed the stories in this Collection.',
    [statNames.AVG_REPINS]:
      'Average number of saves per post in the filtered set of media.',
    [statNames.COMMENTS]:
      'Number of comments associated with the filtered set of media.',
    [statNames.ENGAGEMENT_RATE]: `Average Follower Engagement Rate per post in the filtered set of media.
                                               Follower Engagement Rate is likes plus comments of each post divided by current followers.`,
    [statNames.FOLLOWER_ENGAGEMENT_RATE]: `Average Follower Engagement Rate per post in the filtered set of media.
                                                       Follower Engagement Rate is likes plus comments of each post divided by current followers.`,
    [statNames.INTERACTIONS]:
      'Total number of likes and comments associated with the filtered set of media.',
    [statNames.LIKES]:
      'Number of likes associated with the filtered set of media',
    [statNames.POTENTIAL_IMPRESSIONS]: `Estimated number of times the filtered set of media has been viewed, based on the poster's current follower
                                                     count.`,
    [statNames.REACH_ENGAGEMENT_RATE]: `Average Engagement Rate per post in the filtered set of media. Engagement Rate is likes plus
                                                     comments of each post divided by the number of unique users who have seen this media.`,
    [statNames.TOTAL_COMMENTS]:
      'Number of comments associated with the filtered set of media.',
    [statNames.TOTAL_IMPRESSIONS]:
      'Sum of views across the stories in this Collection.',
    [statNames.TOTAL_LIKES]:
      'Number of likes associated with the filtered set of media',
    [statNames.TOTAL_REPINS]:
      'Total number of saves per post in the filtered set of media.',
  };

  curalate.constant('StatBubbleNames', statNames);
  curalate.constant('StatBubbleLabels', statLabels);
  curalate.constant('StatBubbleTooltips', statTooltips);

  curalate.component('statBubbleV2', {
    template: require('@legacy-components/common/stat-bubble-v2/stat-bubble-v2.html'),
    bindings: {
      value: '<',
      label: '<',
      tt: '<',
      filter: '<',
      filterParams: '<',
    },
    controllerAs: '$stat',
    controller: [
      '$scope',
      '$filter',
      'STAT_FORMATTERS',
      function ($scope, $filter, STAT_FORMATTERS) {
        $scope.model = {};

        this.$onInit = function () {
          const self = this;
          let args;

          if (self.filter) {
            args = [self.value].concat(self.filterParams || []);

            switch (self.filter) {
              case STAT_FORMATTERS.NUMBER:
                $scope.model.formattedValue = $filter('readableNumber')(
                  ...args,
                );
                break;
              case STAT_FORMATTERS.PRICE:
                $scope.model.formattedValue = $filter('readablePrice')(...args);
                break;
              case STAT_FORMATTERS.PERCENT:
                $scope.model.formattedValue = $filter('readablePercent')(
                  ...args,
                );
                break;
              case STAT_FORMATTERS.COMPLETE_NUMBER:
                $scope.model.formattedValue = $filter('reallyReadableNumber')(
                  ...args,
                );
                break;
              default:
                $scope.model.formattedValue = $filter(self.filter)(...args);
            }
          }
        };
      },
    ],
  });
})();
